import React from "react";
import SkeletonElement from "./SkeletonElement";

export default function SkeletonNews() {
  return (
    <div className="py-10 skeletonWrapper px-9 h-[300px] animate-pulse mx-1">
      <SkeletonElement type="thumnailFull" />
      <SkeletonElement type="text" />
    </div>
  );
}
